import React, { ComponentProps } from 'react'

export const MoneyCycleIcon = (props: ComponentProps<'svg'>) => (
    <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.9754 6.84712H14.6668L12.3146 4.40402C11.5573 3.61795 10.614 3.05267 9.57945 2.765C8.54494 2.47734 7.4557 2.47742 6.42123 2.76525C5.38676 3.05308 4.44352 3.6185 3.68633 4.40468C2.92914 5.19087 2.3847 6.1701 2.10772 7.24394M1.33424 14.7498V10.9182M1.33424 10.9182H5.02566M1.33424 10.9182L3.68574 13.3613C4.44304 14.1473 5.38636 14.7126 6.42087 15.0003C7.45538 15.288 8.54463 15.2879 9.5791 15.0001C10.6136 14.7122 11.5568 14.1468 12.314 13.3606C13.0712 12.5744 13.6156 11.5952 13.8926 10.5214M14.6668 3.01553V6.84558"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.99984 11.5496V8.88291M6.6665 10.2971L7.05717 10.59C7.57761 10.9806 8.42162 10.9806 8.9425 10.59C9.46339 10.1993 9.46339 9.56645 8.9425 9.17579C8.6825 8.98024 8.34117 8.88291 7.99984 8.88291M7.99984 8.88291C7.67761 8.88291 7.35539 8.78514 7.10961 8.59003C6.61806 8.19937 6.61806 7.5665 7.10961 7.17584C7.60117 6.78518 8.3985 6.78518 8.89006 7.17584L9.0745 7.3225M7.99984 8.88291L7.99984 6.21631"
            stroke="#333333"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
)
